import React from 'react';
import {IPropsSearchItem} from "./constants";

const FactoryComponent: React.FC<IPropsSearchItem> = () => <div />;

export default React.memo(FactoryComponent);
